import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

emailjs.init("Qt78XLDJz1DD1D2cV");

const Contact = () => {
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState({ message: '', type: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    emailjs.sendForm(
      'service_mbfjtka',
      'template_xh9msg7',
      e.target,
      'Qt78XLDJz1DD1D2cV'
    )
    .then((response) => { 
      setStatus({ 
        message: 'Message sent successfully!',
        type: 'success'
      });
      setFormData({
        user_name: '',
        user_email: '',
        subject: '',
        message: ''
      });
      setTimeout(() => {
        setStatus({ message: '', type: '' });
      }, 3000);
    })
    .catch((error) => { 
      setStatus({ 
        message: 'Failed to send message. Please try again.',
        type: 'error'
      });
      setTimeout(() => {
        setStatus({ message: '', type: '' });
      }, 3000);
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <h2 className="section-title">Get In Touch</h2>
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <span className="info-icon">📍</span>
              <div className="info-details">
                <h3>Location</h3>
                <p>Nairobi, Kenya</p>
              </div>
            </div>
            <div className="info-item">
              <span className="info-icon">📧</span>
              <div className="info-details">
                <h3>Email</h3>
                <p>oyugijudith68@gmail.com</p>
              </div>
            </div>
            <div className="info-item">
              <span className="info-icon">📱</span>
              <div className="info-details">
                <h3>Phone</h3>
                <p>+254 742 749466</p>
              </div>
            </div>
            <div className="social-links">
              <a href="https://ke.linkedin.com/in/judithoyugi-dev" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="https://github.com/JudithOyugi" target="_blank" rel="noopener noreferrer">GitHub</a>
              <a href="https://twitter.com/OyugiJudy" target="_blank" rel="noopener noreferrer">Twitter</a>
            </div>
          </div>
                      <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                          <input
                            type="text"
                            name="user_name"
                            placeholder="Your Name"
                            value={formData.user_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="email"
                            name="user_email"
                            placeholder="Your Email"
                            value={formData.user_email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        
                        <div className="form-group">
                          <textarea
                            name="message"
                            placeholder="Your Message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          ></textarea>
                        </div>
                        {status.message && (
                          <div className={`status-popup ${status.type}`}>
                            {status.message}
                          </div>
                        )}
                        <button type="submit" className="submit-btn">Send Message</button>
                      </form>
                    </div>
      </div>
    </section>
  );
};

export default Contact;